import { SmsWhitelistService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { smsKeys } from 'app/queries/sms/smsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof smsKeys.whitelist>>;

export const createFetchSmsWhitelistQueryFn =
  (call: TCall) =>
  async ({ signal }: TParams) =>
    (await call(() => cancelOnSignal(SmsWhitelistService.findAll(), signal))) ?? [];
